import { dfpNetDebtComponentResponse } from '@interfaces/dfp/response/dfpNetDebtComponentResponse';
import { DfpPeriodAwareRow, dfpColumnKey } from '@models/dfp/dfp-column.model';

/**
 * Dívida Líquida nos Pontos de destaque (card 3669, fase 1). O backend calcula tudo: o valor da linha e a composição
 * (`netDebtComposition`, cada parcela com o sinal da fórmula). Aqui só se reorganiza a composição por coluna para a
 * tabela abrir as parcelas sob o "+" da linha. Nenhuma soma é feita na tela.
 */

/** Prefixo da linha "Dívida Líquida" nos Destaques (`HighlightsPrefixConstants.NetDebt`). */
export const NET_DEBT_HIGHLIGHT_PREFIX = '3';

/** Uma parcela da composição, com o valor (já com o sinal da fórmula) de cada coluna. */
export interface DfpNetDebtCompositionRow {
  /** Chave estável da parcela (enum do backend). */
  key: string;
  label: string;
  /** `signedValue` do backend por chave de coluna (`dfpColumnKey`). */
  signedValuesByColumn: Record<string, number>;
}

type RowWithComposition = DfpPeriodAwareRow & {
  netDebtComposition?: dfpNetDebtComponentResponse[] | null;
};

/**
 * Parcelas da composição das linhas de uma Dívida Líquida (uma linha por coluna), na ordem em que o backend as manda
 * (a mesma da memória de cálculo). Linha sem composição não contribui; sem nenhuma, devolve lista vazia e a linha
 * fica sem o "+".
 */
export function buildNetDebtCompositionRows(
  rows: RowWithComposition[]
): DfpNetDebtCompositionRow[] {
  const byKey = new Map<string, DfpNetDebtCompositionRow>();

  for (const row of rows ?? []) {
    for (const part of row.netDebtComposition ?? []) {
      const key = String(part.component);
      let compositionRow = byKey.get(key);
      if (!compositionRow) {
        compositionRow = { key, label: part.label, signedValuesByColumn: {} };
        byKey.set(key, compositionRow);
      }
      compositionRow.signedValuesByColumn[dfpColumnKey(row)] = part.signedValue;
    }
  }

  return Array.from(byKey.values());
}
